import { BaseService } from '../../../../../core/services/base.service';
import { StepsClients } from '../model/steps-clients.model';

export class StepsClientsService {
   static async Get(companyId: string): Promise<StepsClients[]> {
    try {
      const response = await BaseService.Get(`/companies/${companyId}/clients`);
      if (response && Array.isArray(response?.content)) return response.content; 
      if (Array.isArray(response)) return response;                              
      
      console.log('Unexpected response format (clients):', response);
      return [];
    } catch (error) {
      console.error('Error fetching clients:', error);
      return [];
    }
  }

  static async Post(companyId: string, client: StepsClients): Promise<StepsClients> {
    return await BaseService.Post(`/companies/${companyId}/clients`, {
      name: client.name,
      website: client.website,
      active: client.active,
    });
  }
}
